/**
 * Created by andy on 2018/6/22.
 */

import http from '@/http'

export default {

  list(page, success){
    http.get('wxconfig/list',
             {page:page}, success);
  },

  search(page, key, success){
    http.get('wxconfig/search',
      {page:page, key: key}, success);
  },

  save(wxconfig, success){

    http.postBody("wxconfig/add", wxconfig, success);
  },

  update(wxconfig, success){
    http.postBody("wxconfig/edit",wxconfig, success);
  },

  delete(id, success){
    http.get("wxconfig/delete/"+id, success);

  },

}



// WEBPACK FOOTER //
// ./src/api/weixin/wxconfig.js